import { buildScopedPath } from "../utils/account-context";

export const ROUTE_PATHS = Object.freeze({
  login: "/login",
  register: "/register",
  verifyEmail: "/verify-email",
  googleAuthCallback: "/auth/google/callback",
  choosePath: "/choose-path",
  saasStart: "/start",
  pricingFaq: "/pricing/faq",
  enterpriseContact: "/enterprise/contact",
  dashboard: "/dashboard",
  campaigns: "/campaigns",
  templates: "/templates",
  /** Additive Designer Agent create (does not replace Create Design). */
  designerAgentCreate: "/designer-agent/create",
  campaignAdd: "/campaigns/add",
  actors: "/actors",
  users: "/users",
  branding: "/branding",
  accountSettings: "/account-settings",
  /** SuperAdmin-only manage settings (Details, Config, Feature Toggles, etc.). */
  superAdminSettings: "/super-admin-settings",
  /** Static marketing pitch hub (public/marketing-demos); login page links here on non-prod. */
  marketingDemosHub: "/marketing-demos/hub.html",
  tenantSettings: "/tenant-settings", // Backward-compatible alias.
  manageTags: "/manage-tags",
  /** TVD-1301/TVD-1304: SaaS self-serve billing hub (Free/Premium plan, credits, invoices). */
  billing: "/billing",
  buyCredits: "/billing/buy-credits",
  paymentHistory: "/billing/payments",
  paymentDetail: "/billing/payments/:paymentId",
  invoices: "/billing/invoices",
  creditLedger: "/billing/credit-ledger",
  billingFaq: "/billing/faq",
  plans: "/plans",
  /** Authenticated Free Starter Home (checklist) — distinct from public /start landing. */
  starterHome: "/starter",
  checkout: "/billing/checkout",
  paymentReturn: "/billing/payment-return",
  paymentSuccess: "/billing/payment-success",
  paymentFailed: "/billing/payment-failed",
  paywallFreeAvatar: "/paywalls/free-avatar",
  paywallZeroCredits: "/paywalls/zero-credits",
  crm: "/crm",
  trustvidCrm: "/crm/trustvid",
  /** Legacy SuperAdmin path — redirects into scoped Super Admin Settings (tenant isolation). */
  adminAccounts: "/admin/settings/accounts",
  adminAccountsAdd: "/admin/settings/accounts/add",
  lmsEngagement: "/lms-engagement",
  workflows: "/workflows",
  workflowsNewRun: "/workflows/runs/new",
  workflowsBulk: "/workflows/runs/bulk",
  workflowsRunDetail: "/workflows/runs/:runId",
  workflowsTemplateEdit: "/workflows/templates/:templateId",
  /** TVD-1338: Super Admin video pipeline observability. */
  videoPipeline: "/video-pipeline",
});

export const routeFor = Object.freeze({
  campaignView: (campaignId) => `/campaigns/${campaignId}/view`,
  campaignEdit: (campaignId) => `/campaigns/${campaignId}/edit`,
  draftCampaignEdit: (campaignId) => `/edit-draft-campaigns/${campaignId}`,
  lmsEngagementDetail: (draftId) => `/lms-engagement/${draftId}`,
});

export const toScopedRoute = (accountId, routePath) => buildScopedPath(accountId, routePath);
